import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildMakeModelActionsPath, PredictionsModel } from 'client/data/models/predictions';
import { MultivariateExperiment } from 'site-modules/shared/components/experiment';

function OnlinePersonalizationUI({ actionSpaceId, action, defaultAction, children, isTestEnabled }) {
  return (
    <MultivariateExperiment
      name={actionSpaceId}
      featureFlagId={isTestEnabled ? `${actionSpaceId}-ff` : 'disabled-ff'}
      defaultDimensions={{
        eop_should_treat: null,
        action: null,
      }}
    >
      {({ eop_should_treat: eopShouldTreat, action: forcedAction }) => {
        // non-null 'action' expected only for testing via query params
        const currentAction = forcedAction || (eopShouldTreat === 'true' ? action || defaultAction : defaultAction);

        return children(currentAction);
      }}
    </MultivariateExperiment>
  );
}

OnlinePersonalizationUI.propTypes = {
  actionSpaceId: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  action: PropTypes.string,
  defaultAction: PropTypes.string,
  isTestEnabled: PropTypes.bool,
};

OnlinePersonalizationUI.defaultProps = {
  action: null,
  defaultAction: null,
  isTestEnabled: true,
};

export const OnlinePersonalization = connectToModel(OnlinePersonalizationUI, {
  action: bindToPath(
    ({ makeSlug, modelSlug, actionSpaceId, isTestEnabled }) =>
      isTestEnabled && buildMakeModelActionsPath({ make: makeSlug, model: modelSlug, actionSpaceId }),
    PredictionsModel,
    actions => get(actions, '[0]')
  ),
});

OnlinePersonalization.propTypes = {
  makeSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
  actionSpaceId: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  defaultAction: PropTypes.string,
  isTestEnabled: PropTypes.bool,
};

OnlinePersonalization.defaultProps = {
  defaultAction: null,
  isTestEnabled: true,
};
